import React, { useState } from "react";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./ResetPassword.module.scss";
import WelcomePanel from "../components/WelcomePanel/WelcomePanel";
import FormElement from "components/FormElement/FormElement";
import InputAdornment from "components/InputAdornment/InputAdornment";
import Button from "components/Button/Button";
import logo from "assets/img/compliancy-group-logo.png";
import { submitUserResetPasswordAction } from "store/actions/Actions";

const ResetPassword = (props) => {
    let { hash } = useParams();
    const [stateErrors, setStateErrors] = useState({
        password: "",
        "confirm-password": "",
      });

    const handleForgot = (e) => {
        const password = document.getElementById('pass-reset').value;
        const pass_confirm = document.getElementById('pass-reset-confirm').value;
        if (!password || password === "") {
            setStateErrors((s) => ({ ...s, password: 'Password is required!' }));
        } else if (password && password !== pass_confirm) {
            setStateErrors((s) => ({ ...s, "confirm-password": `Password doesn't match` }));
        } else {
            props.submitUserResetPasswordAction({ password, hash });
        }
    }
    return (
        <WelcomePanel type="reset">
            <div className={styles["login-panel-heading"]}>
                <img className={styles.logo} src={logo} alt="" />
            </div>
            <div className={styles["login-panel-content"]}>
                <p className={styles.welcome}>Enter your new password!</p>
                <FormElement
                    errorMessage={stateErrors.password}
                >
                    <InputAdornment iconStart="fal fa-lock-alt">
                        <input
                            onChange={() => setStateErrors((s) => ({ ...s, "password": `` }))}
                            type="password"
                            autoComplete="off"
                            placeholder="Enter new password"  
                            name="pass"
                            id="pass-reset"
                        />
                    </InputAdornment>
                </FormElement>
                <FormElement
                    errorMessage={stateErrors["confirm-password"]}
                >
                    <InputAdornment iconStart="fal fa-lock-alt">
                        <input
                            onChange={() => setStateErrors((s) => ({ ...s, "confirm-password": `` }))}
                            type="password"
                            autoComplete="off"
                            placeholder="Confirm new password"
                            name="pass"
                            id="pass-reset-confirm"
                        />
                    </InputAdornment>
                </FormElement>
            </div>
            <div className={styles["login-panel-footer"]}>
                <Button text={"CHANGE PASSWORD"} onClick={handleForgot} />
            </div>
        </WelcomePanel>
    )
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    submitUserResetPasswordAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPassword));
